<template>
  <div class="construction-group">
    <SimpleTable
      showIndex
      ref="vtableRef"
      table-code="constructionGroup"
      :columns="columns"
      :data="tableData"
      :menus="['查询', '插入', '批量删除', '批量修改']"
      @modify-data-change="onModifyDataChange"
    />
  </div>
</template>

<script>
// 导入VTable组件
import SimpleTable from '@/components/SimpleTable'

import {
  sortRecords,
  debounceAfter,
  aggregationAmount,
  aggregationSUM
} from '@/utils/index'

export default {
  name: 'ConstructionGroup',
  components: { SimpleTable },
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      columns: [
        {
          field: 'name',
          title: '施工班组',
          canEdit: true,
          canModify: true,
          width: 200
        }
      ],
      loading: false,
      tableData: []
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      this.getTableData()
    },

    async getTableData() {
      this.loading = true
      const res = await this.$service.get('/construction-group/list')
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    openModal(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.detailsRef.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post('/construction-group/batch', arr)
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.construction-group {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 500px;
  height: 100%;
  .btns {
    margin-bottom: 12px;
  }
}
</style>
